import { render, staticRenderFns } from "./DoubleClickToDelete.vue?vue&type=template&id=70de45f7&scoped=true&"
import script from "./DoubleClickToDelete.vue?vue&type=script&lang=js&"
export * from "./DoubleClickToDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de45f7",
  null
  
)

export default component.exports